import {MouseEvent, KeyboardEvent} from 'react';

const SPACE_KEY_CODE = 32;
const ENTER_KEY_CODE = 13;

/**
 * Handles click events on non semantic button elements
 * Returns whether the given event is a click event or
 * the space bar or enter key has been pressed.
 */
export default function a11yClick(
  event: MouseEvent | KeyboardEvent<HTMLElement>
): boolean {
  if (event.type === 'click') {
    return true;
  }

  if (event.type === 'keydown' || event.type === 'keypress') {
    const {charCode, keyCode} = event as KeyboardEvent<HTMLElement>;
    const code = charCode || keyCode;

    if (code === SPACE_KEY_CODE || code === ENTER_KEY_CODE) {
      event.preventDefault();
      return true;
    }
  }

  return false;
}
